<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/organization'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom>
          <img [src]="'assets/images/organization.svg'">
        </div>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{'organization.new_organization' | translate}}
          </div>
          <div class="subtitle secondary-text">
            <span>{{'organization.organization_detail' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <button mat-raised-button
        class="save-product-button mat-white-bg mt-16 mt-sm-0"
        [disabled]="formGroup && formGroup.invalid" (click)="addOrganization(true)">
        <span>{{'main.add' | translate}}</span>
      </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">

        <div class="content-block">
          <cropper [avatar]="''" [page]="'org'" (sendImg)="setImg($event)"></cropper>

        </div>
        <div class="content-block">
          <form [formGroup]="formGroup" class="canton-form">
            <mat-form-field class="width-100">
              <mat-label>{{ 'organization.name' | translate }}</mat-label>
              <input formControlName="name" matInput required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-50">
              <mat-label>{{ 'organization.country' | translate }}</mat-label>
              <mat-select formControlName="countryId" required>
                @for (country of countries; track country.id) {
                  <mat-option [value]="country.id">
                    {{country.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-50">
              <mat-label>{{ 'organization.canton' | translate }}</mat-label>
              <mat-select formControlName="cityId" required multiple>
                @for (city of cities; track city) {
                  <mat-option [value]="city.id">
                    {{city.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="width-100">
              <mat-label>{{ 'organization.city' | translate }}</mat-label>
              <input formControlName="cityLocation" matInput required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-100">
              <mat-label>{{ 'user.lang' | translate }}</mat-label>
              <mat-select formControlName="lang" required>
                @for (lang of languages; track lang) {
                  <mat-option [value]="lang.value">
                    {{lang.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-100">
              <mat-label>{{ 'organization.organizationType' | translate }}</mat-label>
              <mat-select formControlName="organizationTypeId" required>
                @for (type of types; track type) {
                  <mat-option [value]="type.id">
                    {{type.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="width-50">
              <mat-label>{{ 'organization.address' | translate }}</mat-label>
              <input formControlName="address" matInput>
            </mat-form-field>
            <mat-form-field class="width-50">
              <mat-label>{{ 'organization.postcode' | translate }}</mat-label>
              <input formControlName="postcode" matInput>
            </mat-form-field>
            <mat-form-field class="width-100">
              <mat-label>{{ 'organization.website' | translate }}</mat-label>
              <input formControlName="website" matInput>
            </mat-form-field>
            <mat-form-field class="width-100">
              <mat-label>{{ 'user.phone' | translate }}</mat-label>
              <input formControlName="phone" matInput appPhoneMask>
            </mat-form-field>
            @if (formGroup.get('whatsapp')?.enabled) {
              <mat-checkbox class="width-100" formControlName="whatsapp">{{'WhatsApp' | translate}}</mat-checkbox>
            }
            @if (formGroup.get('allowCompetency')?.enabled) {
              <mat-checkbox class="width-100" formControlName="allowCompetency">{{'competency.competency' | translate}}</mat-checkbox>
            }
            @if (formGroup.get('allowTimeAndBudget')?.enabled) {
              <mat-checkbox class="width-100" formControlName="allowTimeAndBudget">{{'organization.allowTimeAndBudget' | translate}}</mat-checkbox>
            }
          </form>
        </div>

      </div>
      <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

  </div>
  <!-- / CENTER -->
</div>

